module.exports = __webpack_public_path__ + "img/banner1_1248.830de7aa.png";